var _style, _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI",
    viewBox: "0 0 34 34"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#505050}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#f9f9f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13 1c6.6 0 12 5.4 12 12s-5.4 12-12 12S1 19.6 1 13 6.4 1 13 1m0-1C5.8 0 0 5.8 0 13s5.8 13 13 13 13-5.8 13-13S20.2 0 13 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32 34c-.5 0-1-.2-1.4-.6l-9-9c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0l9 9c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6z"
  }))));
};
export default __webpack_public_path__ + "static/media/search-icon.adf36efe.svg";
export { SvgSearchIcon as ReactComponent };